<template>
    <div v-if="unit" class="grid grid-cols-main rounded-lg p-1" :style="{'gap': '1rem'}">
        <div class="grid gap-2 col-span" :style="{'grid-template-columns': 'repeat(2, minmax(0, 1fr))', 'gap': '.5rem'}">
            <div class="d-flex flex-wrap gap-x-2">
                <p class="font-bold">
                    Naziv objekta:
                </p>
                <p>
                    {{ unit.objekt_naziv || '/' }}
                </p>
            </div>
            <div class="d-flex flex-wrap gap-x-2">
                <p class="font-bold">
                    Naziv vhoda:
                </p>
                <p>
                    {{ unit.vhod_sifra }} {{ unit.vhod_naziv }}
                </p>
            </div>
        </div>
        <div class="d-flex flex-column gap-2">
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Objekt:
                </p>
                <p>
                    {{ unit.objekt_sifra || '/' }}
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Enota:
                </p>
                <p>
                    {{ unit.enota_sifra || '/' }}
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Velikost bruto:
                </p>
                <p>
                    {{ convertFloat(unit.velikost_bruto) || '/' }} m<sup>2</sup>
                </p>
            </div>
        </div>
        <div class="d-flex flex-column gap-2">
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    GURS. št. enote:
                </p>
                <p>
                    {{ unit.stev_stanovanja || '/' }}
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    GURS št. stavbe:
                </p>
                <p>
                    {{ unit.stev_stavbe || '/' }}
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Velikost neto:
                </p>
                <p>
                    {{ convertFloat(unit.velikost_neto) || '/' }} m<sup>2</sup>
                </p>
            </div>
        </div>
        <div class="d-flex flex-column gap-2">
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Invent. št.:
                </p>
                <p>
                    {{ unit.inventarna_stevilka || '/' }}
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Vrsta prostora:
                </p>
                <p>
                    {{ unit.vrsta_prostora || '/' }}
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Št. oseb:
                </p>
                <p>
                    {{ unit.stev_oseb || '/' }}
                </p>
            </div>
        </div>
        <div class="d-flex flex-column gap-2">
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Zap. št. enote:
                </p>
                <p>
                    {{ unit.zaporedna || '/' }}
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Solast. del.:
                </p>
                <p>
                    {{ convertFloat(unit.solastniski_delez) || '/' }} %
                </p>
            </div>
            <div class="grid grid-cols gap-x-2">
                <p class="font-bold">
                    Št. psov:
                </p>
                <p>
                    {{ unit.stev_zivali || '/' }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import {convertFloat} from '@/libs/helpers'

    export default {
        methods: {convertFloat},
        props: {
            unit: {
                type: Object,
                default: undefined
            }
        }
    }
</script>

<style scoped>
p {
  margin: 0;
}
.grid {
  display: grid;
}
.grid-cols {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
@media (min-width: 640px) {
  .grid-cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.grid-cols-main {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  background-color: #eaf3f9;
}
.col-span {
  grid-column: span 2 / span 2;
}
@media (min-width: 1280px) {
  .grid-cols-main {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .col-span {
    grid-column: span 4 / span 4;
  }
}
.gap-4 {
  gap: 1rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.font-bold {
  font-weight: 700;
}
</style>